__turbopack_context__.v({
  "action": "O6_CCa_action",
  "column1": "O6_CCa_column1",
  "column2": "O6_CCa_column2",
  "fullWidth": "O6_CCa_fullWidth",
  "spinner": "O6_CCa_spinner",
});
